/* eslint no-param-reassign: ["error", { "props": false }], no-return-assign: "error" */
import React, { PureComponent } from 'react';

import {
  StyledSearchFilterWrapper,
  StyledSearchFilterLabel,
  StyledSFRowName,
  StyledSFRowTitle,
  StyledRemoveFilters,
  StyledBtnFilters,
  StyledIconClose,
  StyledButtonDesktop,
  StyledRowInputs,
  StyledButtonsModal,
  StyledBlockForm,
  StyledButton,
  StyledInput
} from '../style';

import { Close } from '../../../../../assets/images/index';
import DropdownInput from '../../DropdownInput';
import InputDate from '../../InputDate';
import {
  initialValues,
  resetValues,
  viewsSelector,
  // typeAppSelector,
  contentTypeSelector
} from './types';
import { getLabel, validateData } from './functions';

class FilterNotificationForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = initialValues;
    this.inputFields = undefined;
  }

  componentDidMount() {
    this.inputFields = Array.from(document.querySelectorAll('input'));
  }

  validateField = (value, evt) => {
    if (value && value?.type) {
      const name = value.type;
      const validName = name.charAt(0).toUpperCase() + name.slice(1);
      let newValue;
      if (value?.value?.value !== undefined) {
        newValue = value.value.value;
      } else if (value?.value !== undefined) {
        newValue = value.value;
      }
      const result = value === '' || validateData(name, newValue);
      this.setState({ [`valid${validName}`]: result, [name]: newValue }, () =>
        this.getErrors()
      );
      getLabel(value?.type);
    } else if (evt) {
      const { name } = evt.target;
      const validName = name.charAt(0).toUpperCase() + name.slice(1);
      const result = value === '' || validateData(name, value);
      this.setState({ [`valid${validName}`]: result, [name]: value }, () =>
        this.getErrors()
      );
    }
  };

  fillClick = type => {
    const { setFilter } = this.props;
    const {
      title,
      date,
      contentType,
      viewed,
      validForm
      // typeApp
    } = this.state;
    if (type === 'reset') {
      const filter = {};
      this.onResetFilter();
      setFilter(filter);
      return filter;
    }
    if (validForm === true) {
      const filter = {};
      const fields = [
        { name: 'title', value: title },
        { name: 'sendDate', value: date },
        // { name: 'typeApp', value: typeApp },
        { name: 'contentType', value: contentType },
        { name: 'viewed', value: viewed }
      ];
      fields.map(el => {
        if (el && el.value !== undefined && el.value !== '') {
          const { value, name } = el;
          filter[name] = value;
        }
        return null;
      });
      setFilter(filter);
      return filter;
    }
    return null;
  };

  getErrors = () => {
    const {
      validViewed,
      // validTypeApp,
      validDate,
      validContentType,
      validTitle
    } = this.state;
    if (
      validViewed === true ||
      validViewed === false ||
      // validTypeApp === true ||
      validDate === true ||
      validContentType === true ||
      validTitle === true
    ) {
      this.setState({
        validForm: true
      });
    } else {
      this.setState({
        validForm: false
      });
    }
  };

  onResetFilter = () => this.setState({ ...resetValues, validForm: false });

  render() {
    const { onClick, closeModal, modalActive, filter } = this.props;
    const { validForm } = this.state;
    return (
      <React.Fragment>
        <StyledSearchFilterWrapper display="block" modalActive={modalActive}>
          <StyledSFRowTitle display="flex">filtrar</StyledSFRowTitle>
          <StyledRowInputs>
            <StyledSFRowName display="flex">
              <StyledBlockForm modalActive={modalActive}>
                <StyledSearchFilterLabel id="viewed" for="viewed">
                  No leídos
                </StyledSearchFilterLabel>
                <div className="wrapped-campo">
                  <DropdownInput
                    id="inputViewed"
                    name="viewed"
                    value={this.state.viewed || ''}
                    className="form-dropdown"
                    list={viewsSelector}
                    label={getLabel(this.state, filter, 'viewed')}
                    labelNotification
                    onSelect={value =>
                      this.validateField({ value, type: 'viewed' })
                    }
                    small
                    enabled
                    placeholder={filter?.viewed}
                    modalActive={modalActive}
                  />
                </div>
              </StyledBlockForm>
              <StyledBlockForm modalActive={modalActive}>
                <StyledSearchFilterLabel id="date" for="date">
                  Fecha
                </StyledSearchFilterLabel>
                <InputDate
                  id="inputDate"
                  name="date"
                  value={this.state.date}
                  format="YYYY-MM-DD"
                  className="form-input-date"
                  onChange={value =>
                    this.validateField({ value, type: 'date' })
                  }
                  placeholder={this.state?.date}
                  clearDate={this.state.date === undefined}
                />
              </StyledBlockForm>
              {/* <StyledBlockForm modalActive={modalActive}>
                <StyledSearchFilterLabel id="typeApp" for="typeApp">
                  Tipo de Notificación
                </StyledSearchFilterLabel>
                <div className="wrapped-campo">
                  <DropdownInput
                    id="inputTypeApp"
                    name="typeApp"
                    value={this.state.typeApp}
                    className="form-dropdown"
                    list={typeAppSelector}
                    label={getLabel(this.state, filter, 'typeApp')}
                    labelNotification
                    onSelect={value =>
                      this.validateField({ value, type: 'typeApp' })
                    }
                    small
                    enabled
                    modalActive={modalActive}
                    placeholder={filter?.typeApp}
                  />
                </div>
                  </StyledBlockForm> */}
              <StyledBlockForm modalActive={modalActive}>
                <StyledSearchFilterLabel id="contentType" for="contentType">
                  Tipo de Contenido
                </StyledSearchFilterLabel>
                <div className="wrapped-campo">
                  <DropdownInput
                    id="inputContentType"
                    value={this.state.contentType}
                    name="contentType"
                    className="form-dropdown"
                    list={contentTypeSelector}
                    label={getLabel(this.state, filter, 'contentType')}
                    labelNotification
                    onSelect={value =>
                      this.validateField({ value, type: 'contentType' })
                    }
                    small
                    enabled
                    modalActive={modalActive}
                    placeholder={filter?.contentType}
                  />
                </div>
              </StyledBlockForm>
              <StyledBlockForm modalActive={modalActive}>
                <StyledSearchFilterLabel id="title" for="title">
                  Titulo
                </StyledSearchFilterLabel>
                <StyledInput
                  id="inputTitle"
                  name="title"
                  value={this.state.title}
                  placeholder={filter?.title || ''}
                  onChange={value =>
                    this.validateField({ value, type: 'title' })
                  }
                />
              </StyledBlockForm>
            </StyledSFRowName>
          </StyledRowInputs>
          {filter && filter !== {} && Object.keys(filter).length !== 0 && (
            <StyledRemoveFilters>
              <StyledIconClose svg={Close} />
              <StyledBtnFilters
                onClick={() => {
                  this.inputFields.map(element => (element.value = null));
                  onClick(this.fillClick('reset'));
                }}
              >
                Borrar filtros
              </StyledBtnFilters>
            </StyledRemoveFilters>
          )}
          {modalActive ? (
            <StyledButtonsModal>
              <StyledButton
                onClick={closeModal}
                modalActive={modalActive}
                modal
              >
                Cancelar
              </StyledButton>
              <StyledButton
                secondary
                onClick={onClick(this.fillClick)}
                disabled={!validForm}
              >
                Guardar
              </StyledButton>
            </StyledButtonsModal>
          ) : (
            <StyledButtonDesktop
              onClick={() => onClick(this.fillClick())}
              modalActive={modalActive}
              disabled={!validForm}
              large
            >
              Buscar
            </StyledButtonDesktop>
          )}
        </StyledSearchFilterWrapper>
      </React.Fragment>
    );
  }
}

export default FilterNotificationForm;
